// extracted by mini-css-extract-plugin
export default {"BuildControls":"BuildControls_BuildControls__XBune","OrderButton":"BuildControls_OrderButton__pks-T","popIn":"BuildControls_popIn__qxaZn"};